import React from "react";
import Header from "../../../shared/PageHeader";
import PageFooter from "../../../shared/PageFooter";
import FAQComponent from "app/scenes/SalesPage/FaqSection";
import StepsSection from "app/scenes/SalesPage/StepsLandingPage";
import ContactForm from "../QuerySection";
import "./LandingPage.scss";
import FinkraftBenefits from "../FinkraftBenefits";
import TryProductSection from "../TryProductSection";
import AboutUsHero from "../AboutUsHero";
import AboutFinkraft from "../AboutFinkraft";
import HeroSectionAbout from "../HeroSectionAbout";

function LandingPage() {
  const stepsData = {
    subtitle: "ABOUT",
    title: "Meet Finkraft",
    description:
      "Finkraft.ai is a Bengaluru-headquartered fintech platform specialising in GST compliance, invoice automation and reconciliation for enterprises in travel, hospitality and beyond. Its AI-driven products include:",
    steps: [
      {
        icon: (
          <svg
            width="800"
            height="800"
            viewBox="0 0 800 800"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M188 612C179.281 603.446 173.763 592.158 172.368 580.024C170.972 567.889 173.784 555.643 180.333 545.333L309 339.333L550.333 98C570.546 77.9456 597.86 66.6844 626.333 66.6667C640.385 66.6667 654.299 69.4343 667.28 74.8116C680.262 80.1888 692.058 88.0704 701.994 98.0063C711.93 107.942 719.811 119.738 725.188 132.72C730.566 145.701 733.333 159.615 733.333 173.667C733.316 202.14 722.054 229.454 702 249.667L460.667 491L254.667 619.667C244.357 626.216 232.111 629.028 219.976 627.632C207.842 626.237 196.554 620.719 188 612Z"
              stroke="#8E2157"
              stroke-width="60.6667"
              stroke-miterlimit="10"
            />
            <path
              d="M612 339.333L491 460.667L642.333 733.333L733.333 672.667L612 339.333Z"
              stroke="#8E2157"
              stroke-width="60.6667"
              stroke-miterlimit="10"
            />
            <path
              d="M460.667 188L339.333 309L66.6667 157.667L127.333 66.6667L460.667 188Z"
              stroke="#8E2157"
              stroke-width="60.6667"
              stroke-miterlimit="10"
            />
            <path
              d="M233.333 460.667H97.0001L66.6667 551.667L188 612L248.667 733.333L339.333 703V566.667"
              stroke="#8E2157"
              stroke-width="60.6667"
              stroke-miterlimit="10"
            />
          </svg>
        ),
        title: "Airline Reconciliation Solution",
        description:
          "Auto-extracts airline invoices, cross-validates data, and ensures accurate GST reconciliation with maximum ITC recovery.",
      },
      {
        icon: (
          <svg
            width="800"
            height="800"
            viewBox="0 0 800 800"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 700H166.667M166.667 700H333.333M166.667 700V100M333.333 700H466.667M333.333 700V533.333H266.667C333.333 444.443 466.667 444.443 533.333 533.333H466.667V700M166.667 100H100M166.667 100H633.333M466.667 700H633.333M633.333 700H700M633.333 700V100M633.333 100H700M300 216.667H333.333M466.667 216.667H500M300 350H333.333M466.667 350H500"
              stroke="#8E2157"
              stroke-width="66.6667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
        title: "Hotel Reconciliation Solution",
        description:
          "Performs six-way matching on hotel folios, e-invoices and booking data, capturing 100 % of eligible ITC and eliminating manual errors.",
      },
      {
        icon: (
          <svg
            width="800"
            height="800"
            viewBox="0 0 800 800"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 266.667C100 211.438 144.772 166.667 200 166.667H600C655.23 166.667 700 211.438 700 266.667V533.333C700 588.563 655.23 633.333 600 633.333H200C144.772 633.333 100 588.563 100 533.333V266.667Z"
              stroke="#8E2157"
              stroke-width="66.6667"
            />
            <path
              d="M100 333.333H700"
              stroke="#8E2157"
              stroke-width="66.6667"
            />
            <path
              d="M466.667 500H566.667"
              stroke="#8E2157"
              stroke-width="66.6667"
              stroke-linecap="round"
            />
          </svg>
        ),
        title: "AR / AP Automation",
        description:
          "Monitors ERP and GSTN feeds to flag missing e-invoices and secure every credit with minimal manual effort.",
      },
    ],
    buttonText: "Visit Finkraft",
  };

  const faqData = {
    title: "FAQs",
    subtitle: "Here are answers to questions our clients ask.",
    items: [
      {
        question: "Lorem ipsum dolor sit amet, consectetur.",
        answer:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      },
      {
        question: "Lorem ipsum dolor sit amet consectetur. Eget ultricies.",
        answer:
          "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
      {
        question:
          "Eget ultricies ut sit velit magna dolor porttitor magna fringilla. Volutpat est in arcu tristique commodo.",
        answer:
          "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
      },
      {
        question: "Lorem ipsum dolor sit amet, consectetur.",
        answer:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
      },
      {
        question: "Lorem ipsum dolor sit amet consectetur. Eget ultricies.",
        answer:
          "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.",
      },
    ],
  };

  const handleGetStarted = () => {
    console.log("Get Started button clicked");
  };

  return (
    <div className="landing-page">
      <div className="page-header">
        <Header />
      </div>

      <div className="page-body">
        <AboutUsHero />
        <AboutFinkraft
          title={stepsData.title}
          subtitle={stepsData.subtitle}
          description={stepsData.description}
          steps={stepsData.steps}
          buttonText={stepsData.buttonText}
          onButtonClick={handleGetStarted}
        />
        {/* <StepsSection
        title={stepsData.title}
        subtitle={stepsData.subtitle}
        description={stepsData.description}
        steps={stepsData.steps}
        buttonText={stepsData.buttonText}
        onButtonClick={handleGetStarted}
      /> */}
        {/* <FAQComponent
          title={faqData.title}
          subtitle={faqData.subtitle}
          items={faqData.items}
        /> */}
        {/* <TryProductSection /> */}
        <HeroSectionAbout />
      </div>

      <div className="page-footer">
        <PageFooter companyName="Finkraft.ai" year={2025} />
      </div>
    </div>
  );
}

export default LandingPage;
